"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _color = _interopRequireDefault(require("./color"));
var optionPosition = {
  top: 'calc(100% + 1px)'
};
var dropdown = {
  onFocus: "\n    border: 1px solid ".concat(_color.default.secondary, ";\n    outline: 1px solid ").concat(_color.default.secondary, ";\n    border-radius: 0;\n    box-shadow: none;\n  "),
  optionPosition: optionPosition
};
var _default = exports.default = dropdown;